import { FormSectionHandler } from '../entity.handler';
import { DeviceProviderResponse, DeviceProviderUpdateRequest, IdName } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField, IdNameComboValueHandlers } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, ComboField } from '../utils';
import { ICONS } from '../icons';

interface EditorValues {
    name?: string;
    deviceProviderType?: IdName;
}

export class DeviceProviderDetailsSectionHandler implements FormSectionHandler<DeviceProviderResponse, EditorValues> {

    type = 'form';
    icon = ICONS.deviceprovider;
    bulk = false;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        public creating: boolean
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.DEVICEPROVIDER.DETAILS.${key}`, values);
    }

    applyUpdate(entity: DeviceProviderResponse, payload: DeviceProviderUpdateRequest): Promise<DeviceProviderResponse> {
        return this.admin.applyUpdate(api => api.entities.updateDeviceProvider(entity.id, payload));
    }

    mapEntityToEditor(entity: DeviceProviderResponse): Promise<EditorValues> {
        const result = {
            name: entity.name,
            deviceProviderType: entity.deviceProviderType,
        };
        Object.keys(result).forEach(key => result[key] === undefined && delete result[key]); // strip undefined properties from the object
        return Promise.resolve(result);
    }

    mapEditorToEntity(entity: DeviceProviderUpdateRequest, values: EditorValues): Promise<DeviceProviderUpdateRequest> {

        const patch: DeviceProviderUpdateRequest = {
            name: values.name,
            deviceProviderType: values.deviceProviderType,
        };
        Object.keys(patch).forEach(key => patch[key] === undefined && delete patch[key]); // strip undefined properties from the object

        return Promise.resolve(EntityUtils.mergeFields(['name', 'deviceProviderType'], patch, entity));

    }

    async getFields(entity: DeviceProviderResponse): Promise<FormBuilderField[]> {
        const company = await this.admin.getCached(`getCompany/${this.ownerId}`, api => api.accounts.getCompany(this.ownerId));
        const types = await this.admin.getCached(`listDeviceProviderTypes/${this.ownerId}/0/100/name/null`, api => api.entities.listDeviceProviderTypes(this.ownerId, 0, 100, 'name', null));
        const fields: FormBuilderField[] = [
            { ...ComboField('deviceProviderType', this.translate('FIELDS.TYPE'), true, EntityUtils.idNameToComboValues(types.items.filter(x => x.companyTypes.includes(company.type))), IdNameComboValueHandlers), readonly: !this.creating },
            TextField('name', this.translate('FIELDS.NAME'), true, 1, 255),
        ];
        return EntityUtils.prepareBulk(!entity, [], fields);

    }

}
